"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_PREVIOUSLY_ACCEPTED_STATUS = exports.UPDATE_CURRENTLY_ACCEPTED_STATUS = exports.TOGGLE_TAC_MODAL = exports.TERM_STATUS_BY_TYPE_FETCHED = exports.TERMS_UPDATED = exports.TERMS_STATUS_FETCHING = exports.TERMS_STATUS_FETCHED = exports.TERMS_FETCHING = exports.TERMS_FETCHED = exports.SHARED_INFO_FETCHING = exports.SHARED_INFO_FETCHED = exports.LOA_STATUS_FETCHING = exports.LOA_STATUS_FETCHED = exports.LOA_STATUS_FAILED = exports.LOA_CONTENT_FETCHING = exports.LOA_CONTENT_FETCHED = exports.LOA_CONTENT_FAILED = exports.CARDS_TERM_STATUS_TYPE = void 0;
exports.default = terms;
exports.fetchLOAContent = fetchLOAContent;
exports.fetchLOAStatus = fetchLOAStatus;
exports.fetchSharedInfoContent = fetchSharedInfoContent;
exports.fetchTermStatusByType = fetchTermStatusByType;
exports.fetchTermsContent = fetchTermsContent;
exports.fetchTermsStatus = fetchTermsStatus;
exports.initialState = void 0;
exports.launchTaCModal = launchTaCModal;
exports.toggleTaCModal = toggleTaCModal;
exports.updateCurrentlyAccepted = updateCurrentlyAccepted;
exports.updateTerms = updateTerms;
var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
var _merge3 = _interopRequireDefault(require("lodash/merge"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var listingActions = _interopRequireWildcard(require("../listing/listingModule"));
var _utils = require("../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t10 in e) "default" !== _t10 && {}.hasOwnProperty.call(e, _t10) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t10)) && (i.get || i.set) ? o(f, _t10, i) : f[_t10] = e[_t10]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var TOGGLE_TAC_MODAL = exports.TOGGLE_TAC_MODAL = '@@termsModule/TOGGLE_TAC_MODAL';
var TERMS_FETCHING = exports.TERMS_FETCHING = '@@termsModule/TERMS_FETCHING';
var TERMS_FETCHED = exports.TERMS_FETCHED = '@@termsModule/TERMS_FETCHED';
var UPDATE_PREVIOUSLY_ACCEPTED_STATUS = exports.UPDATE_PREVIOUSLY_ACCEPTED_STATUS = '@@termsModule/UPDATE_PREVIOUSLY_ACCEPTED_STATUS';
var UPDATE_CURRENTLY_ACCEPTED_STATUS = exports.UPDATE_CURRENTLY_ACCEPTED_STATUS = '@@termsModule/UPDATE_CURRENTLY_ACCEPTED_STATUS';
var TERMS_STATUS_FETCHING = exports.TERMS_STATUS_FETCHING = '@@termsModule/TERMS_STATUS_FETCHING';
var TERMS_STATUS_FETCHED = exports.TERMS_STATUS_FETCHED = '@@termsModule/TERMS_STATUS_FETCHED';
var TERMS_UPDATED = exports.TERMS_UPDATED = '@@termsModule/TERMS_UPDATED';
var SHARED_INFO_FETCHING = exports.SHARED_INFO_FETCHING = '@@termsModule/SHARED_INFO_FETCHING';
var SHARED_INFO_FETCHED = exports.SHARED_INFO_FETCHED = '@@termsModule/SHARED_INFO_FETCHED';
var TERM_STATUS_BY_TYPE_FETCHED = exports.TERM_STATUS_BY_TYPE_FETCHED = '@@termsModule/TERM_STATUS_BY_TYPE_FETCHED';
var LOA_STATUS_FETCHING = exports.LOA_STATUS_FETCHING = '@@termsModule/LOA_STATUS_FETCHING';
var LOA_STATUS_FETCHED = exports.LOA_STATUS_FETCHED = '@@termsModule/LOA_STATUS_FETCHED';
var LOA_STATUS_FAILED = exports.LOA_STATUS_FAILED = '@@termsModule/LOA_STATUS_FAILED';
var LOA_CONTENT_FETCHING = exports.LOA_CONTENT_FETCHING = '@@termsModule/LOA_CONTENT_FETCHING';
var LOA_CONTENT_FETCHED = exports.LOA_CONTENT_FETCHED = '@@termsModule/LOA_CONTENT_FETCHED';
var LOA_CONTENT_FAILED = exports.LOA_CONTENT_FAILED = '@@termsModule/LOA_CONTENT_FAILED';
var CARDS_TERM_STATUS_TYPE = exports.CARDS_TERM_STATUS_TYPE = 'cards';
var COMMON_HEADERS = {
  headers: {
    'Content-Type': 'application/json'
  }
};
var REQUEST_FAILED = 'request failed';
function fetchTermStatusByType(type) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var response, responseBody, _yield$response$json, accepted, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return (0, _isomorphicFetch.default)("".concat((0, _utils.getAPIEndpoint)(), "/v3/terms/").concat(type, "/status"), {
              headers: _objectSpread({}, COMMON_HEADERS.headers),
              credentials: 'include'
            });
          case 1:
            response = _context.v;
            if (!(response.status !== 200)) {
              _context.n = 3;
              break;
            }
            _context.n = 2;
            return response.text();
          case 2:
            responseBody = _context.v;
            throw Error("Get term status for ".concat(type, " terms returned status ").concat(response.status, "\n").concat(responseBody));
          case 3:
            _context.n = 4;
            return response.json();
          case 4:
            _yield$response$json = _context.v;
            accepted = _yield$response$json.accepted;
            dispatch({
              type: TERM_STATUS_BY_TYPE_FETCHED,
              termType: type,
              termAccepted: accepted
            });
            _context.n = 6;
            break;
          case 5:
            _context.p = 5;
            _t = _context.v;
            _nuiLogger.default.error({
              description: "Failed to fetch term status for ".concat(type, " terms"),
              category: 'terms-status-action',
              error: _t
            });
            throw _t;
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[0, 5]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
function fetchLOAStatus(userId) {
  return /*#__PURE__*/function () {
    var _asyncFetchLOAStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var stateId, _getState, profile, options, response, status, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            // there are two places to get userId, we should consolidate.
            // one comes from us encoding what we have from session, the other from an api call
            stateId = (0, _get2.default)(getState(), 'userProfile.profile.UserID', false);
            if (!(!userId && !stateId)) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2, Promise.reject(new Error('could not find a userId in fetchLOAStatus call or state')));
          case 1:
            _getState = getState(), profile = _getState.userProfile.profile;
            dispatch({
              type: LOA_STATUS_FETCHING
            });
            options = _objectSpread({
              method: 'GET'
            }, COMMON_HEADERS);
            options.credentials = 'include';
            _context2.p = 2;
            _context2.n = 3;
            return (0, _isomorphicFetch.default)("".concat((0, _utils.getAPIEndpoint)(profile), "/v3/terms/loa/status"), options);
          case 3:
            response = _context2.v;
            _context2.n = 4;
            return response.json();
          case 4:
            status = _context2.v;
            dispatch({
              type: LOA_STATUS_FETCHED,
              term: "".concat(status.type, "Status"),
              status: status.accepted
            });
            return _context2.a(2, status);
          case 5:
            _context2.p = 5;
            _t2 = _context2.v;
            dispatch({
              type: LOA_STATUS_FAILED,
              message: REQUEST_FAILED
            });
            return _context2.a(2, Promise.reject(REQUEST_FAILED));
        }
      }, _callee2, null, [[2, 5]]);
    }));
    function asyncFetchLOAStatus(_x2, _x3) {
      return _asyncFetchLOAStatus.apply(this, arguments);
    }
    return asyncFetchLOAStatus;
  }();
}
function fetchLOAContent() {
  return /*#__PURE__*/function () {
    var _asyncFetchLOAContent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var state, _state$userProfile, _state$userProfile2, profile, _state$userPrefs$loca, lang, options, response, html, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            state = getState();
            if (!((0, _has2.default)(state, 'terms.loa.content.html') && state.terms.loa.content.html)) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2, Promise.resolve((0, _get2.default)(state, 'terms.loa.content.html')));
          case 1:
            _state$userProfile = state.userProfile, _state$userProfile2 = _state$userProfile === void 0 ? {} : _state$userProfile, profile = _state$userProfile2.profile, _state$userPrefs$loca = state.userPrefs.localeData.lang, lang = _state$userPrefs$loca === void 0 ? 'en-us' : _state$userPrefs$loca;
            options = {
              method: 'GET'
            };
            dispatch({
              type: LOA_CONTENT_FETCHING
            });
            _context3.p = 2;
            _context3.n = 3;
            return (0, _isomorphicFetch.default)("".concat((0, _utils.getAPIEndpoint)(profile), "/v3/terms/loa?lang=").concat(lang), options);
          case 3:
            response = _context3.v;
            if (!(response.status !== 200)) {
              _context3.n = 4;
              break;
            }
            dispatch({
              type: LOA_CONTENT_FAILED,
              message: response.statusText
            });
            _context3.n = 6;
            break;
          case 4:
            _context3.n = 5;
            return response.text();
          case 5:
            html = _context3.v;
            dispatch({
              type: LOA_CONTENT_FETCHED,
              html: html
            });
          case 6:
            _context3.n = 8;
            break;
          case 7:
            _context3.p = 7;
            _t3 = _context3.v;
            dispatch({
              type: LOA_CONTENT_FAILED,
              message: _t3.message
            });
          case 8:
            return _context3.a(2);
        }
      }, _callee3, null, [[2, 7]]);
    }));
    function asyncFetchLOAContent(_x4, _x5) {
      return _asyncFetchLOAContent.apply(this, arguments);
    }
    return asyncFetchLOAContent;
  }();
}
function fetchTermsStatus() {
  return /*#__PURE__*/function () {
    var _asyncFetchTermsStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var options, _getState2, _getState2$userProfil, _getState2$userProfil2, profile, termsStatusReponse, termsJSON, accepted, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            dispatch({
              type: TERMS_STATUS_FETCHING
            });
            options = _objectSpread({
              method: 'GET'
            }, COMMON_HEADERS);
            options.credentials = 'include';
            _getState2 = getState(), _getState2$userProfil = _getState2.userProfile, _getState2$userProfil2 = _getState2$userProfil === void 0 ? {} : _getState2$userProfil, profile = _getState2$userProfil2.profile; // Get term status, update their status in the store. If either
            // has not abeen accepted, return false, else return true
            _context4.p = 1;
            _context4.n = 2;
            return (0, _isomorphicFetch.default)("".concat((0, _utils.getAPIEndpoint)(profile), "/v3/terms/appcenter/status"), options);
          case 2:
            termsStatusReponse = _context4.v;
            _context4.n = 3;
            return termsStatusReponse.json();
          case 3:
            termsJSON = _context4.v;
            accepted = true;
            if (!termsJSON.accepted) {
              accepted = termsJSON.accepted;
            }
            dispatch({
              type: UPDATE_PREVIOUSLY_ACCEPTED_STATUS,
              term: termsJSON.type,
              status: termsJSON.accepted
            });
            dispatch({
              type: TERMS_STATUS_FETCHED
            });
            return _context4.a(2, accepted);
          case 4:
            _context4.p = 4;
            _t4 = _context4.v;
            throw _t4;
          case 5:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 4]]);
    }));
    function asyncFetchTermsStatus(_x6, _x7) {
      return _asyncFetchTermsStatus.apply(this, arguments);
    }
    return asyncFetchTermsStatus;
  }();
}
function fetchTermsContent() {
  return /*#__PURE__*/function () {
    var _asyncFetchTermsContent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch, getState) {
      var _getState3, _getState3$userProfil, _getState3$userProfil2, profile, appcenterTerms, options, response, data, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            _getState3 = getState(), _getState3$userProfil = _getState3.userProfile, _getState3$userProfil2 = _getState3$userProfil === void 0 ? {} : _getState3$userProfil, profile = _getState3$userProfil2.profile, appcenterTerms = _getState3.terms.appcenterTerms;
            if (!appcenterTerms) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            dispatch({
              type: TERMS_FETCHING
            });
            options = {
              method: 'GET',
              headers: {}
            };
            _context5.p = 2;
            _context5.n = 3;
            return (0, _isomorphicFetch.default)("".concat((0, _utils.getAPIEndpoint)(profile), "/v3/terms/"), options);
          case 3:
            response = _context5.v;
            if (!(response.status !== 200)) {
              _context5.n = 4;
              break;
            }
            // error occured after terms fetch
            dispatch({
              type: TERMS_FETCHED,
              terms: []
            });
            _context5.n = 6;
            break;
          case 4:
            _context5.n = 5;
            return response.json();
          case 5:
            data = _context5.v;
            dispatch({
              type: TERMS_FETCHED,
              terms: data
            });
          case 6:
            _context5.n = 8;
            break;
          case 7:
            _context5.p = 7;
            _t5 = _context5.v;
            // error thrown during terms fetch
            dispatch({
              type: TERMS_FETCHED,
              terms: []
            });
          case 8:
            return _context5.a(2);
        }
      }, _callee5, null, [[2, 7]]);
    }));
    function asyncFetchTermsContent(_x8, _x9) {
      return _asyncFetchTermsContent.apply(this, arguments);
    }
    return asyncFetchTermsContent;
  }();
}
function fetchSharedInfoContent(listingId, v1ListingId) {
  return /*#__PURE__*/function () {
    var _asyncFetchSharedInfoContent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dispatch, getState) {
      var _getState4, _getState4$userProfil, _getState4$userProfil2, profile, _getState4$userPrefs$, lang, ID, _getState5, _getState5$listing$li, _getState5$listing$li2, _getState5$listing$li3, _getState5$listing$li4, _getState5$listing$li5, _getState5$listing$li6, partnerAppId, options, response, json, data, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            _getState4 = getState(), _getState4$userProfil = _getState4.userProfile, _getState4$userProfil2 = _getState4$userProfil === void 0 ? {} : _getState4$userProfil, profile = _getState4$userProfil2.profile, _getState4$userPrefs$ = _getState4.userPrefs.localeData.lang, lang = _getState4$userPrefs$ === void 0 ? 'en-us' : _getState4$userPrefs$;
            if ((0, _has2.default)(getState(), "listing[".concat(listingId, "].data.core"))) {
              ID = listingId;
            } else {
              ID = v1ListingId;
            }
            _getState5 = getState(), _getState5$listing$li = _getState5.listing[listingId], _getState5$listing$li2 = _getState5$listing$li === void 0 ? {} : _getState5$listing$li, _getState5$listing$li3 = _getState5$listing$li2.data, _getState5$listing$li4 = _getState5$listing$li3 === void 0 ? {} : _getState5$listing$li3, _getState5$listing$li5 = _getState5$listing$li4.core, _getState5$listing$li6 = _getState5$listing$li5 === void 0 ? {} : _getState5$listing$li5, partnerAppId = _getState5$listing$li6.partnerAppId;
            if (partnerAppId) {
              _context6.n = 1;
              break;
            }
            dispatch({
              type: SHARED_INFO_FETCHED,
              data: []
            });
            return _context6.a(2);
          case 1:
            options = {
              method: 'GET',
              headers: {}
            };
            _context6.p = 2;
            dispatch({
              type: SHARED_INFO_FETCHING
            });
            _context6.n = 3;
            return (0, _isomorphicFetch.default)("".concat((0, _utils.getAPIEndpoint)(profile), "/v3/listings/").concat(ID, "/scopes?lang=").concat(lang), options);
          case 3:
            response = _context6.v;
            if (!(response.status !== 200)) {
              _context6.n = 4;
              break;
            }
            // case error
            // we specificially set undefined here instead of [], becuase the [] case can still be valid
            dispatch({
              type: SHARED_INFO_FETCHED,
              data: undefined
            });
            _context6.n = 6;
            break;
          case 4:
            _context6.n = 5;
            return response.json();
          case 5:
            json = _context6.v;
            data = json.map(function (i) {
              var scopeTablePath = i.code === 'user_read' ? 'user-read2' : i.code.toLowerCase().split('.').join('-');
              return _objectSpread(_objectSpread({}, i), {}, {
                scopeTablePath: scopeTablePath
              });
            });
            dispatch({
              type: SHARED_INFO_FETCHED,
              data: data
            });
          case 6:
            _context6.n = 8;
            break;
          case 7:
            _context6.p = 7;
            _t6 = _context6.v;
            dispatch({
              type: SHARED_INFO_FETCHED,
              data: undefined
            });
          case 8:
            return _context6.a(2);
        }
      }, _callee6, null, [[2, 7]]);
    }));
    function asyncFetchSharedInfoContent(_x0, _x1) {
      return _asyncFetchSharedInfoContent.apply(this, arguments);
    }
    return asyncFetchSharedInfoContent;
  }();
}
function updateTerms(_x10) {
  return _updateTerms.apply(this, arguments);
}
function _updateTerms() {
  _updateTerms = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(type) {
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          return _context8.a(2, /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(dispatch, getState) {
              var _getState7, _getState7$userPrefs, _getState7$userPrefs2, csrfToken, response, _t7, _t8, _t9, _t0, _t1;
              return _regenerator().w(function (_context7) {
                while (1) switch (_context7.p = _context7.n) {
                  case 0:
                    _getState7 = getState(), _getState7$userPrefs = _getState7.userPrefs, _getState7$userPrefs2 = _getState7$userPrefs === void 0 ? {} : _getState7$userPrefs, csrfToken = _getState7$userPrefs2.csrf_token;
                    _context7.p = 1;
                    _context7.n = 2;
                    return (0, _isomorphicFetch.default)("".concat((0, _utils.getAPIEndpoint)(), "/v3/terms/").concat(type, "/status"), {
                      method: 'PUT',
                      credentials: 'include',
                      headers: {
                        'X-CSRF-Token': csrfToken
                      }
                    });
                  case 2:
                    response = _context7.v;
                    if (response.ok) {
                      _context7.n = 4;
                      break;
                    }
                    _t7 = Error;
                    _t8 = "Response code ".concat(response.status, " when attempting to accept ").concat(type, " term\n");
                    _context7.n = 3;
                    return response;
                  case 3:
                    _t9 = _context7.v.text();
                    _t0 = _t8.concat.call(_t8, _t9);
                    throw _t7(_t0);
                  case 4:
                    dispatch({
                      type: UPDATE_PREVIOUSLY_ACCEPTED_STATUS,
                      term: type,
                      status: true
                    });
                    _context7.n = 6;
                    break;
                  case 5:
                    _context7.p = 5;
                    _t1 = _context7.v;
                    _nuiLogger.default.error({
                      err: _t1,
                      category: 'update-terms-action-error'
                    });
                    throw _t1;
                  case 6:
                    return _context7.a(2);
                }
              }, _callee7, null, [[1, 5]]);
            }));
            return function (_x11, _x12) {
              return _ref3.apply(this, arguments);
            };
          }());
      }
    }, _callee8);
  }));
  return _updateTerms.apply(this, arguments);
}
function toggleTaCModal(tAndCLinkClicked) {
  return function (dispatch) {
    return dispatch({
      type: TOGGLE_TAC_MODAL,
      tAndCLinkClicked: tAndCLinkClicked
    });
  };
}
function launchTaCModal(_ref2) {
  var tAndCLinkClicked = _ref2.tAndCLinkClicked,
    _ref2$flow = _ref2.flow,
    flow = _ref2$flow === void 0 ? '' : _ref2$flow,
    listingId = _ref2.listingId,
    v1ListingId = _ref2.v1ListingId,
    _ref2$needAnAccountCl = _ref2.needAnAccountClicked,
    needAnAccountClicked = _ref2$needAnAccountCl === void 0 ? {
      needAnAccountClicked: false
    } : _ref2$needAnAccountCl;
  return function (dispatch, getState) {
    var _getState6 = getState(),
      _getState6$terms = _getState6.terms,
      appcenterTerms = _getState6$terms.appcenterTerms,
      appcenterStatus = _getState6$terms.appcenterStatus;
    if (needAnAccountClicked) {
      dispatch(listingActions.toggleNeedAnAccountClicked(true));
    }
    if (tAndCLinkClicked && !appcenterTerms) {
      dispatch(toggleTaCModal(tAndCLinkClicked));
      dispatch(fetchTermsContent());
      dispatch(fetchSharedInfoContent(listingId, v1ListingId));
    } else {
      var ACTermsOK = appcenterStatus.previouslyAccepted || appcenterStatus.currentlyAccepted;
      if (flow === 'WEBFLOW' && ACTermsOK) {
        dispatch(listingActions.connectListing(listingId, v1ListingId));
        return;
      }
      dispatch(toggleTaCModal());
      dispatch(fetchTermsContent());
      dispatch(fetchSharedInfoContent(listingId, v1ListingId));
    }
  };
}
function updateCurrentlyAccepted(field, value) {
  return {
    type: UPDATE_CURRENTLY_ACCEPTED_STATUS,
    field: field,
    value: value
  };
}
var initialState = exports.initialState = {
  isTaCModalOpen: false,
  tAndCLinkClicked: false,
  appcenterStatus: {
    previouslyAccepted: false,
    currentlyAccepted: false
  },
  loa: {
    status: {
      previouslyAccepted: false,
      currentlyAccepted: false
    },
    content: {
      html: ''
    }
  },
  cards: {
    accepted: false,
    content: ''
  },
  sharedInfoStatus: {
    currentlyAccepted: false
  },
  sharedInfo: [],
  content: [{
    type: 'appcenter',
    content: ''
  }],
  contentFetched: false,
  sharedInfoFetched: false
};

// this reducer handles everything off of rootState.terms
function terms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case TOGGLE_TAC_MODAL:
      return (0, _merge3.default)({}, state, {
        isTaCModalOpen: !state.isTaCModalOpen,
        tAndCLinkClicked: action.tAndCLinkClicked
      });
    case UPDATE_PREVIOUSLY_ACCEPTED_STATUS:
      {
        switch (action.term) {
          case 'appcenter':
            return _objectSpread(_objectSpread({}, state), {}, {
              appcenterStatus: _objectSpread(_objectSpread({}, state.appcenterStatus), {}, {
                previouslyAccepted: action.status
              })
            });
          case 'loa':
            return _objectSpread(_objectSpread({}, state), {}, {
              loa: _objectSpread(_objectSpread({}, state.loa), {}, {
                status: _objectSpread(_objectSpread({}, state.loa.status), {}, {
                  previouslyAccepted: action.status
                })
              })
            });
          case 'cards':
            return _objectSpread(_objectSpread({}, state), {}, {
              cards: _objectSpread(_objectSpread({}, state.cards), {}, {
                accepted: action.status
              })
            });
          default:
            return state;
        }
      }
    case UPDATE_CURRENTLY_ACCEPTED_STATUS:
      // loa has a different (newer, better) schema than appcenter and ereceipt
      if (action.field === 'loaStatus') {
        return (0, _merge3.default)({}, state, {
          loa: {
            status: {
              currentlyAccepted: action.value
            }
          }
        });
      }
      // cards has a different (newer, better) schema than loa
      if (action.field === CARDS_TERM_STATUS_TYPE) {
        return _objectSpread(_objectSpread({}, state), {}, {
          cards: _objectSpread(_objectSpread({}, state.cards), {}, {
            accepted: action.value
          })
        });
      }
      return (0, _merge3.default)({}, state, _defineProperty({}, action.field, {
        currentlyAccepted: action.value
      }));
    case TERMS_FETCHED:
      return _objectSpread(_objectSpread({}, state), {}, {
        content: action.terms,
        cards: _objectSpread(_objectSpread({}, state.cards), {}, {
          content: action.terms.length === 0 ? '' : action.terms.find(function (term) {
            return (term === null || term === void 0 ? void 0 : term.type) === 'cards';
          }).content
        }),
        contentFetched: true
      });
    case SHARED_INFO_FETCHING:
      return _objectSpread(_objectSpread({}, state), {}, {
        sharedInfoFetched: false
      });
    case SHARED_INFO_FETCHED:
      return _objectSpread(_objectSpread({}, state), {}, {
        sharedInfo: action.data,
        sharedInfoFetched: true
      });
    case LOA_STATUS_FETCHING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loa: _objectSpread(_objectSpread({}, state.loa), {}, {
          status: {
            readyState: 'FETCHING'
          }
        })
      });
    case LOA_STATUS_FETCHED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loa: _objectSpread(_objectSpread({}, state.loa), {}, {
          status: {
            readyState: 'FETCHED',
            previouslyAccepted: action.status,
            currentlyAccepted: action.status
          }
        })
      });
    case LOA_STATUS_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loa: _objectSpread(_objectSpread({}, state.loa), {}, {
          status: {
            readyState: 'FAILED',
            message: action.message
          }
        })
      });
    case LOA_CONTENT_FETCHING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loa: _objectSpread(_objectSpread({}, state.loa), {}, {
          content: {
            readyState: 'FETCHING'
          }
        })
      });
    case LOA_CONTENT_FETCHED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loa: _objectSpread(_objectSpread({}, state.loa), {}, {
          content: {
            readyState: 'FETCHED',
            html: action.html
          }
        })
      });
    case LOA_CONTENT_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loa: _objectSpread(_objectSpread({}, state.loa), {}, {
          content: {
            readyState: 'FAILED',
            message: action.message
          }
        })
      });
    case TERM_STATUS_BY_TYPE_FETCHED:
      {
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.termType, _objectSpread(_objectSpread({}, state[action.termType]), {}, {
          accepted: action.termAccepted
        })));
      }
    default:
      return state;
  }
}